import React, { useEffect, useState } from "react";

function Destination() {
  const [destinations, setDestinations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchDestinations = async () => {
      try {
        const response = await fetch("https://yourapi.com/destinations");
        if (!response.ok) throw new Error("Failed to fetch destinations");

        const data = await response.json();
        setDestinations(data);
      } catch (err) {
        console.error(err);
        setError("Unable to load destinations. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchDestinations();
  }, []);

  if (loading) return <p className="text-center">Loading destinations...</p>;
  if (error) return <p className="text-center text-danger">{error}</p>;

  return (
    <div>
      <div className="container-fluid bg-primary py-5 mb-5 hero-header">
        <div className="container py-5">
          <div className="row justify-content-center py-5">
            <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
              <h1 className="display-3 text-white animated slideInDown">
                Destination
              </h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li
                    className="breadcrumb-item text-white active"
                    aria-current="page"
                  >
                    Destination
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>

      {/* Destination Start */}
      <div className="container-xxl py-5 destination">
        <div className="container">
          <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
            <h6 className="section-title bg-white text-center text-primary px-3">
              Destination
            </h6>
            <h1 className="mb-5">Popular Destination</h1>
          </div>

          <div className="row g-3">
            {destinations.map((dest, index) => (
              <div
                key={dest.id}
                className={
                  index === destinations.length - 1
                    ? "col-lg-5 col-md-6 wow zoomIn"
                    : index < 3
                      ? "col-lg-7 col-md-6"
                      : "col-lg-6 col-md-12 wow zoomIn"
                }
                data-wow-delay={`${0.1 + index * 0.2}s`}
                style={index === destinations.length - 1 ? { minHeight: 350 } : {}}
              >
                <a
                  className="position-relative d-block overflow-hidden"
                  href="#"
                >
                  <img
                    className="img-fluid position-absolute w-100 h-100"
                    src={`assets/img/${dest.image}`}
                    alt={dest.name}
                    style={{ objectFit: "cover" }}
                  />
                  <div className="bg-white text-danger fw-bold position-absolute top-0 start-0 m-3 py-1 px-2">
                    {dest.discount}
                  </div>
                  <div className="bg-white text-primary fw-bold position-absolute bottom-0 end-0 m-3 py-1 px-2">
                    {dest.name}
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Destination End */}
    </div>
  );
}

export default Destination;





// import React from 'react'

// function Destination() {
//   return (
//     <div>
//         <div className="container-fluid bg-primary py-5 mb-5 hero-header">
//     <div className="container py-5">
//       <div className="row justify-content-center py-5">
//         <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
//           <h1 className="display-3 text-white animated slideInDown">
//             Destination
//           </h1>
//           <nav aria-label="breadcrumb">
//             <ol className="breadcrumb justify-content-center">
//               <li className="breadcrumb-item">
//                 <a href="/">Home</a>
//               </li>
//               <li
//                 className="breadcrumb-item text-white active"
//                 aria-current="page"
//               >
//                 Destination
//               </li>
//             </ol>
//           </nav>
//         </div>
//       </div>
//     </div>
//   </div>
//       {/* Destination Start */}
//       <div className="container-xxl py-5 destination">
//       <div className="container">
//         <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
//           <h6 className="section-title bg-white text-center text-primary px-3">
//             Destination
//           </h6>
//           <h1 className="mb-5">Popular Destination</h1>
//         </div>
//         <div className="row g-3">
//           <div className="col-lg-7 col-md-6">
//             <div className="row g-3">
//               <div
//                 className="col-lg-12 col-md-12 wow zoomIn"
//                 data-wow-delay="0.1s"
//               >
//                 <a
//                   className="position-relative d-block overflow-hidden"
//                   href=""
//                 >
//                   <img
//                     className="img-fluid"
//                     src="assets/img/destination-1.jpg"
//                     alt=""
//                   />
//                   <div className="bg-white text-danger fw-bold position-absolute top-0 start-0 m-3 py-1 px-2">
//                     30% OFF
//                   </div>
//                   <div className="bg-white text-primary fw-bold position-absolute bottom-0 end-0 m-3 py-1 px-2">
//                     Thailand
//                   </div>
//                 </a>
//               </div>
//               <div
//                 className="col-lg-6 col-md-12 wow zoomIn"
//                 data-wow-delay="0.3s"
//               >
//                 <a
//                   className="position-relative d-block overflow-hidden"
//                   href=""
//                 >
//                   <img
//                     className="img-fluid"
//                     src="assets/img/destination-2.jpg"
//                     alt=""
//                   />
//                   <div className="bg-white text-danger fw-bold position-absolute top-0 start-0 m-3 py-1 px-2">
//                     25% OFF
//                   </div>
//                   <div className="bg-white text-primary fw-bold position-absolute bottom-0 end-0 m-3 py-1 px-2">
//                     Malaysia
//                   </div>
//                 </a>
//               </div>
//               <div
//                 className="col-lg-6 col-md-12 wow zoomIn"
//                 data-wow-delay="0.5s"
//               >
//                 <a
//                   className="position-relative d-block overflow-hidden"
//                   href=""
//                 >
//                   <img
//                     className="img-fluid"
//                     src="assets/img/destination-3.jpg"
//                     alt=""
//                   />
//                   <div className="bg-white text-danger fw-bold position-absolute top-0 start-0 m-3 py-1 px-2">
//                     35% OFF
//                   </div>
//                   <div className="bg-white text-primary fw-bold position-absolute bottom-0 end-0 m-3 py-1 px-2">
//                     Australia
//                   </div>
//                 </a>
//               </div>
//             </div>
//           </div>
//           <div
//             className="col-lg-5 col-md-6 wow zoomIn"
//             data-wow-delay="0.7s"
//             style={{ minHeight: 350 }}
//           >
//             <a
//               className="position-relative d-block h-100 overflow-hidden"
//               href=""
//             >
//               <img
//                 className="img-fluid position-absolute w-100 h-100"
//                 src="assets/img/destination-4.jpg"
//                 alt=""
//                 style={{ objectFit: "cover" }}
//               />
//               <div className="bg-white text-danger fw-bold position-absolute top-0 start-0 m-3 py-1 px-2">
//                 20% OFF
//               </div>
//               <div className="bg-white text-primary fw-bold position-absolute bottom-0 end-0 m-3 py-1 px-2">
//                 Indonesia
//               </div>
//             </a>
//           </div>
//         </div>
//       </div>
//     </div>
//     {/* Destination Start */}
//     </div>
//   )
// }

// export default Destination
